import { useAdminSender } from "../api";
import type { PlaceDetailsResponse, PlaceRefreshResponse } from "../generatedApi/spotManagerApi";
import type { SkuTier } from "../components/GooglePlaceDetailsModal/types";

export const useGooglePlaces = () => {
  const { sender: getPlaceDetailsSender, isLoading: isLoadingDetails } = useAdminSender({
    apiName: "spot_manager",
    serviceName: "googlePlaces",
    operationId: "getPlaceDetails"
  });

  const { sender: refreshPlaceIdSender, isLoading: isLoadingRefresh } = useAdminSender({
    apiName: "spot_manager",
    serviceName: "googlePlaces",
    operationId: "refreshPlaceId"
  });

  /**
   * Place Details APIを呼び出し
   *
   * NOTE: 自動生成されたAPIクライアントはencodeURI()を使用してパスパラメータをエンコードしますが、
   * encodeURI()は/などの予約文字をエンコードしないため、理論上パストラバーサルのリスクがあります。
   * Google Place IDは通常英数字とハイフンのみで構成されるため、実際のリスクは低いですが、
   * 将来的にはOpenAPI生成設定でENCODE_PATHをencodeURIComponentに変更することを検討してください。
   */
  const fetchPlaceDetails = async (
    placeId: string,
    fields: SkuTier[]
  ): Promise<PlaceDetailsResponse> => {
    try {
      const response = await getPlaceDetailsSender({
        placeId,
        fields: fields.join(",")
      });
      return response as PlaceDetailsResponse;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Place Detailsの取得に失敗しました";
      throw new Error(errorMessage);
    }
  };

  /**
   * place_id洗い替えAPIを呼び出し
   *
   * NOTE: fetchPlaceDetailsと同じく、encodeURI()使用によるパストラバーサルのリスクがありますが、
   * Google Place IDの仕様上、実際のリスクは低いです。
   */
  const refreshPlaceId = async (placeId: string): Promise<PlaceRefreshResponse> => {
    try {
      const response = await refreshPlaceIdSender({
        placeId
      });
      return response as PlaceRefreshResponse;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "place_idの洗い替えに失敗しました";
      throw new Error(errorMessage);
    }
  };

  return {
    fetchPlaceDetails,
    refreshPlaceId,
    loading: isLoadingDetails || isLoadingRefresh
  };
};
